export const SERVICE_ID = "8bc3fe29-d50b-4f30-b000-a04315044a5a";
export const CLIENT_ID = "6124bd05-7627-43d4-9d99-d6d356da0d3e";
